/** Adapter compiled against the canonical, immutable public A7 declarations. */
import { APP_BASE } from './routes.js';
import receipt from '../../provenance/vector-core/IMPORT-RECEIPT.json';
import type { VectorInput, VectorOutput, VectorStatus, VectorEditor } from '../../provenance/vector-core/source-inputs/web/vector-editor/index.js';
export type { VectorInput, VectorOutput, VectorStatus, VectorEditor };
export type VectorFormat = VectorOutput['format'];
type PublicHost = typeof import('../../provenance/vector-core/source-inputs/web/vector-editor/index.js');
export async function loadVectorHost(): Promise<PublicHost> {
  const url = new URL(`${APP_BASE}${receipt.runtimeBase}web/vector-editor/index.js`, location.origin).href;
  const host = await import(/* @vite-ignore */ url) as PublicHost;
  if (host.VECTOR_HOST_API_VERSION !== 1) throw new Error('This Vector runtime does not support the pinned host API.');
  return host;
}
